<div class="cliente-campanha">
    <div class="container-header">
        <div class="container-header-block container-header-area-filter">
            <sgt-area-select
                #areaFilter
                (afterInitialized)="filterInitialization.initializeArea()"
                [(area)]="filter.area"
                [(idArea)]="filter.idArea"
                [isShowNull]="true"
                nullLabel="Todas Áreas"
                nullLabelSelected="Todas Áreas"
                [somenteAtivas]="true"
                (afterSelect)="onFilterChange()">
            </sgt-area-select>
        </div>
        
        <div class="container-header-block container-header-visualizacao">
            <sgt-campanha-visualizacao
                #visualizacaoComponent
                [modoDefault]="visualizacaoModoDefault"
                [storageKey]="visualizacaoStorageKey"
                (changeModo)="onChangeModoVisualizacao()">
            </sgt-campanha-visualizacao>            
        </div>          
    </div>  

    <div class="container-filter">
        <sgt-campanha-filter
            #campanhaFilter
            [initialization]="filterInitialization"
            [storageKey]="filterStorageKey"
            [filter]="filter"
            [isShowRepresentantes]="isShowFilterRepresentantes"
            [isShowCliente]="isShowFilterCliente"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-campanha-filter>
    </div>    

    <div class="container-content">      
        <!-- Table -->
        <sgt-campanha-table
            *ngIf="visualizacaoComponent?.isModoTable()"
            #table
            [filter]="filter"
            [optionsVisibility]="optionsVisibility">
        </sgt-campanha-table>

        <!-- Pipeline -->  
        <sgt-campanha-pipeline
            *ngIf="visualizacaoComponent?.isModoPipeline()"
            #pipeline
            [filter]="filter"
            [optionsVisibility]="optionsVisibility">
        </sgt-campanha-pipeline>   
        
        <!-- Dashboard -->  
        <sgt-campanha-dashboard
            *ngIf="visualizacaoComponent?.isModoDashboard()"
            #dashboard
            [filter]="filter">
        </sgt-campanha-dashboard>           
    </div>    
</div>